var map = {
	"./auth-beach.webp": 3615,
	"./auth-canyon.webp": 86699,
	"./auth-forest.webp": 753,
	"./auth-ocean.webp": 66014,
	"./auth-sakura.webp": 18721,
	"./auth-sea.webp": 22299,
	"./auth-sunset.webp": 75974,
	"./auth-terrain.webp": 98009,
	"./avatar-placeholder.png": 77721,
	"./empty-candidates-ca.png": 92243,
	"./empty-requests.svg": 62147,
	"./empty-search.svg": 65181,
	"./empty-table-transfer.gif": 16073,
	"./empty-templates.png": 82593,
	"./errors/error-empty-list.svg": 47768,
	"./errors/error-no-access.svg": 41108,
	"./errors/error-unexpected.svg": 49373,
	"./icon-desktop-highlight2x.svg": 54556,
	"./illustrations/broken-link.svg": 38355,
	"./illustrations/mail-letters.svg": 72468,
	"./loading-beat.gif": 42640,
	"./no-templates.svg": 67966,
	"./onboarding/empty-onboarding.png": 24233,
	"./onboarding/empty-team.svg": 88142,
	"./onboarding/onboarding-empty-state.svg": 79834,
	"./staffing/all-staffing-empty-state.svg": 46794,
	"./staffing/empty-requests.png": 52215,
	"./supplier/candidates/candidates-empty-state.svg": 95047,
	"./supplier/candidates/empty-candidates.png": 72696,
	"./supplier/requests/empty-offers.png": 9439,
	"./supplier/requests/empty-requests.png": 1276,
	"./supplier/team/empty-team.png": 51634,
	"./team/empty-team.png": 38153,
	"./team/my-team-empty-state.svg": 55367,
	"./trusted-t-icon.svg": 56681,
	"./works-dot-elm.svg": 92908,
	"./works-elm.svg": 88866,
	"./works-logo-dashed.png": 96652,
	"./works-logo-elm.svg": 13416,
	"./works-logo-white.svg": 42995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78103;